import * as React from "react";
const SvgRightioLogoR = props => <svg xmlns="http://www.w3.org/2000/svg" width={242.745} height={249.6} viewBox="0 0 242.745 249.6" {...props}><defs><clipPath id="rightio-logo-(r)_svg__a" clipPathUnits="userSpaceOnUse"><path d="M0 187.2h182.059V0H0Z" /></clipPath></defs><path d="M0 0h182.059v187.2H0Zm12.279 174.921h157.502V12.278H12.279Z" style={{
    fill: "#27348b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  }} transform="matrix(1.33333 0 0 -1.33333 0 249.6)" /><g clipPath="url(#rightio-logo-(r)_svg__a)" transform="matrix(1.33333 0 0 -1.33333 0 249.6)"><path d="M0 0q0-5.281-3.58-8.451t-10.272-3.171h-28.372v23.596h28.021q6.689-.001 10.447-2.935Q-.001 6.103 0 .234Zm.704-24.533q7.865 2.933 12.737 9.215 4.87 6.276 4.871 16.257v.234q0 11.738-7.042 18.783c-5.558 5.554-13.541 8.335-23.948 8.335h-47.623V-50.69h18.077v23.105h24.264L-.48-50.69h21.128z" style={{
      fill: "#27348b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }} transform="translate(111.334 104.867)" /></g></svg>;
export default SvgRightioLogoR;